"use strict";var h=Object.defineProperty;var u=Object.getOwnPropertyDescriptor;var e=(c,o,r,n)=>{for(var i=n>1?void 0:n?u(o,r):o,b=c.length-1,d;b>=0;b--)(d=c[b])&&(i=(n?d(o,r,i):d(i))||i);return n&&i&&h(o,r,i),i};import{html as s,nothing as l}from"@spectrum-web-components/base";import{property as t}from"@spectrum-web-components/base/src/decorators.js";import{ifDefined as a}from"@spectrum-web-components/base/src/directives.js";import"@spectrum-web-components/underlay/sp-underlay.js";import"@spectrum-web-components/button/sp-button.js";import"@spectrum-web-components/dialog/sp-dialog.js";import{DialogBase as m}from"./DialogBase.js";export class DialogWrapper extends m{constructor(){super(...arguments);this.error=!1;this.cancelLabel="";this.confirmLabel="";this.dismissLabel="Close";this.footer="";this.hero="";this.heroLabel="";this.noDivider=!1;this.secondaryLabel="";this.headline=""}static get styles(){return[...super.styles]}get dialog(){return this.shadowRoot.querySelector("sp-dialog")}clickSecondary(){this.dispatchEvent(new Event("secondary",{bubbles:!0}))}clickCancel(){this.dispatchEvent(new Event("cancel",{bubbles:!0}))}clickConfirm(){this.dispatchEvent(new Event("confirm",{bubbles:!0}))}renderDialog(){const r=this.noDivider||!this.headline||this.headlineVisibility==="none";return s`
            <sp-dialog
                ?dismissable=${this.dismissable}
                dismiss-label=${this.dismissLabel}
                ?no-divider=${r}
                ?error=${this.error}
                mode=${a(this.mode)}
                size=${a(this.size)}
            >
                ${this.hero?s`
                          <img
                              src="${this.hero}"
                              slot="hero"
                              aria-hidden=${a(this.heroLabel?void 0:"true")}
                              alt=${a(this.heroLabel?this.heroLabel:void 0)}
                          />
                      `:l}
                ${this.headline?s`
                          <h2
                              slot="heading"
                              ?hidden=${this.headlineVisibility==="none"}
                          >
                              ${this.headline}
                          </h2>
                      `:l}
                <slot></slot>
                ${this.footer?s`
                          <div slot="footer">${this.footer}</div>
                      `:l}
                ${this.cancelLabel?s`
                          <sp-button
                              variant="secondary"
                              treatment="outline"
                              slot="button"
                              @click=${this.clickCancel}
                          >
                              ${this.cancelLabel}
                          </sp-button>
                      `:l}
                ${this.secondaryLabel?s`
                          <sp-button
                              variant="primary"
                              treatment="outline"
                              slot="button"
                              @click=${this.clickSecondary}
                          >
                              ${this.secondaryLabel}
                          </sp-button>
                      `:l}
                ${this.confirmLabel?s`
                          <sp-button
                              variant="accent"
                              slot="button"
                              @click=${this.clickConfirm}
                          >
                              ${this.confirmLabel}
                          </sp-button>
                      `:l}
            </sp-dialog>
        `}}e([t({type:Boolean,reflect:!0})],DialogWrapper.prototype,"error",2),e([t({attribute:"cancel-label"})],DialogWrapper.prototype,"cancelLabel",2),e([t({attribute:"confirm-label"})],DialogWrapper.prototype,"confirmLabel",2),e([t({attribute:"dismiss-label"})],DialogWrapper.prototype,"dismissLabel",2),e([t()],DialogWrapper.prototype,"footer",2),e([t()],DialogWrapper.prototype,"hero",2),e([t({attribute:"hero-label"})],DialogWrapper.prototype,"heroLabel",2),e([t({type:Boolean,reflect:!0,attribute:"no-divider"})],DialogWrapper.prototype,"noDivider",2),e([t({type:String,reflect:!0})],DialogWrapper.prototype,"size",2),e([t({attribute:"secondary-label"})],DialogWrapper.prototype,"secondaryLabel",2),e([t()],DialogWrapper.prototype,"headline",2),e([t({type:String,attribute:"headline-visibility"})],DialogWrapper.prototype,"headlineVisibility",2);
//# sourceMappingURL=DialogWrapper.js.map
